export default __webpack_public_path__ + "static/media/home_intro.0f12a986.jpeg";